<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="BRACNISTATUS.NAZIV.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtNaziv"
                formControlName="Naziv"
                #focusElement                
                [MaxLength]="200"
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'BRACNISTATUS.NAZIV.SINGULAR'"
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                  <span *ngFor="let validation of errorMessages.Naziv">
                    <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                  <!-- <span *ngIf="fc.Naziv.errors.required">Naziv je obavezan podatak</span> -->
                </div>
            </div>
          </div>             
      </div>
    </div>
  </div>
</form>